// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Questions-module__wrapper","welocomTitle":"Questions-module__welocomTitle","customText":"Questions-module__customText"};